import { cdnTemplate, jadeLocals } from 'cdnPreprocessor';

export default function ForgotPassword () {
  return {
    restrict: 'E',
    template: require('./forgot-password.jade')(jadeLocals),
    controller: 'forgotPasswordCtrl',
    controllerAs: 'password',
    scope: {
        passwordRetrieved: '=?',
        toggle: '=?'
    },
    bindToController: true
  }
};



// WEBPACK FOOTER //
// ./source/client/layout-components/account/forgot-password/forgot-password.dir.js